import api from './api';
import type {
  CabWorkbenchMeeting,
  CabWorkbenchMeetingDetail,
} from '../types/cabWorkbench';

export async function fetchCabWorkbenchMeetings(
  from: string,
  to: string
): Promise<CabWorkbenchMeeting[]> {
  const response = await api.get<{ items: CabWorkbenchMeeting[] }>(
    '/cab-workbench/meetings',
    { params: { from, to } }
  );
  return response.data.items ?? [];
}

export async function getCabWorkbenchMeetingDetail(
  meetingId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.get<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}`
  );
  return response.data;
}

export async function becomeCabWorkbenchHost(
  meetingId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/become-host`
  );
  return response.data;
}

export async function startCabWorkbenchMeeting(
  meetingId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/start`
  );
  return response.data;
}

export async function endCabWorkbenchMeeting(
  meetingId: string
): Promise<
  CabWorkbenchMeetingDetail & {
    momEmailSent?: boolean;
    momEmailRecipientCount?: number;
    momEmailError?: string | null;
  }
> {
  const response = await api.post(
    `/cab-workbench/meetings/${meetingId}/end`
  );
  return response.data;
}

export async function sendCabWorkbenchMomEmail(
  meetingId: string
): Promise<
  CabWorkbenchMeetingDetail & {
    momEmailSent?: boolean;
    momEmailRecipientCount?: number;
    momEmailError?: string | null;
  }
> {
  const response = await api.post(`/cab-workbench/meetings/${meetingId}/send-mom`);
  return response.data;
}

export async function pauseCabWorkbenchAgendaItem(
  meetingId: string,
  agendaItemId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/pause`
  );
  return response.data;
}

export async function resumeCabWorkbenchAgendaItem(
  meetingId: string,
  agendaItemId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/resume`
  );
  return response.data;
}

export async function nextCabWorkbenchAgendaItem(
  meetingId: string,
  agendaItemId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/next`
  );
  return response.data;
}

export async function demoteCabWorkbenchAgendaItem(
  meetingId: string,
  agendaItemId: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/demote`
  );
  return response.data;
}

export async function skipCabWorkbenchAgendaItem(
  meetingId: string,
  agendaItemId: string,
  comments?: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.post<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/skip`,
    { comments }
  );
  return response.data;
}

export async function submitCabWorkbenchCabDecision(
  meetingId: string,
  agendaItemId: string,
  decision: 'approved' | 'rejected',
  comments?: string
): Promise<CabWorkbenchMeetingDetail & { cabDecision?: string; cabDecisionMessage?: string }> {
  const response = await api.post(
    `/cab-workbench/meetings/${meetingId}/agenda-items/${agendaItemId}/cab-decision`,
    { decision, comments }
  );
  return response.data;
}

export async function updateCabWorkbenchMeetingNotes(
  meetingId: string,
  meetingNotes: string
): Promise<CabWorkbenchMeetingDetail> {
  const response = await api.put<CabWorkbenchMeetingDetail>(
    `/cab-workbench/meetings/${meetingId}/notes`,
    { meetingNotes }
  );
  return response.data;
}
